import MenuText from "../../../i18n/MenuText";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import { Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import ImageWithPlaceholder from "../../../components/ImageWithPlaceholder";
import {
    formatStockQuantity,
    getRetailAvailableQuantity,
    getRetailDraftSalesQuantity,
} from "../../../shared/utils/companyStockUtils";
import OtherCompanyStockChips from "./OtherCompanyStockChips";

export default function PosItemCard({
    item,
    index,
    onClick,
    isDragDropMode,
    showQtyBadge = false,
    showPriceTag = false,
    promotionLabel,
}) {
    const { t } = useTranslation();
    const { item_code, cover } = item;
    const rawQty = getRetailAvailableQuantity(item);
    const hasQty = rawQty !== undefined && rawQty !== null && rawQty !== "";
    const qty = Number(rawQty);
    const qtyLabel = Number.isFinite(qty) ? formatStockQuantity(qty) : rawQty;
    const isOutOfStock = Number.isFinite(qty) && qty <= 0;
    const retailDraftSalesQty = getRetailDraftSalesQuantity(item);
    const rateValues = [item.standard_rate, item.price_list_rate, item.rate]
        .map((value) => Number(value))
        .filter((value) => Number.isFinite(value));
    const rate = rateValues.find((value) => value > 0) ?? rateValues[0] ?? 0;
    const currency = item.currency || "";
    const priceLabel = `${rate.toFixed(2)}${currency ? ` ${currency}` : ""}`;

    const handleClick = (e) => {
        if (e.defaultPrevented) return;
        if (onClick) {
            onClick(item);
        }
    };

    const imageStyle = {
        width: "100px",
        height: "100px",
        objectFit: "cover",
        borderRadius: "8px",
    };

    return (
        <div
            onClick={handleClick}
            style={{
                width: "100%",
                position: "relative",
                borderRadius: "4px",
                background: "rgba(255, 255, 255, 0.7)",
            }}
        >
            {showQtyBadge && hasQty ? (
                <Chip
                    size="small"
                    label={qtyLabel}
                    color={isOutOfStock ? "error" : "success"}
                    variant="outlined"
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        height: 22,
                        fontSize: "0.72rem",
                        background: "rgba(255, 255, 255, 0.9)",
                        zIndex: 1,
                    }}
                />
            ) : null}
            {showQtyBadge ? (
                <Chip
                    size="small"
                    label={t("retailPos.draftSalesQty", {
                        qty: formatStockQuantity(retailDraftSalesQty),
                    })}
                    variant="outlined"
                    sx={{
                        position: "absolute",
                        top: 8,
                        left: 8,
                        height: 22,
                        maxWidth: "calc(100% - 70px)",
                        fontSize: "0.68rem",
                        background: "rgba(255, 255, 255, 0.92)",
                        color: retailDraftSalesQty > 0 ? "#ed6c02" : "#6c757d",
                        borderColor:
                            retailDraftSalesQty > 0
                                ? "rgba(237, 108, 2, 0.35)"
                                : "rgba(108, 117, 125, 0.24)",
                        zIndex: 1,
                    }}
                />
            ) : null}
            {showPriceTag ? (
                <Chip
                    size="small"
                    label={priceLabel}
                    color="primary"
                    sx={{
                        position: "absolute",
                        right: 8,
                        bottom: 8,
                        height: 24,
                        fontSize: "0.75rem",
                        fontWeight: 700,
                        background: "#e14954",
                        color: "#fff",
                        zIndex: 1,
                    }}
                />
            ) : null}
                         <div className="Item" key={`Item_1_${item_code}`}>
                 <ImageWithPlaceholder
                     src={cover}
                     alt={item.item_name}
                     style={imageStyle}
                 />
                <div
                    style={{
                        // position: 'absolute',
                        top: 0,
                        right: 0,
                        // background: 'rgba(255, 255, 255, 0.7)', // Semi-transparent background
                        padding: "5px",
                        // borderRadius: '4px'
                    }}
                >
                    <div className={"MainDetails"} key={`Item_2_${item_code}`}>
                        <div className={"Name"} key={`Item_name_${item_code}`} style={{fontSize: "18px", lineHeight: "1.2"}}>
                            {<MenuText>{item.item_name}</MenuText>}
                            {promotionLabel && <Chip size="small" color="success" label={promotionLabel} />}
                        </div>
                    </div>
                    {showQtyBadge ? (
                        <OtherCompanyStockChips
                            companyActualQty={item.company_actual_qty}
                            currentCompany={item.stock_company}
                        />
                    ) : null}
                    {isDragDropMode && (
                        <div className={"Name"}>
                            <OpenWithIcon />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
